import { useInfiniteQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { CallFilter, CallLog } from '@/types/calls'

const PAGE_SIZE = 30

interface CallsResponse {
  calls: CallLog[]
  missed_count?: number
  total_today?: number
  unread_voicemail_count?: number
}

/** Liste paginée des appels (infinite query). */
export function useCallLogs(filter: CallFilter = 'all') {
  return useInfiniteQuery({
    queryKey: ['call-logs', filter],
    queryFn: async ({ pageParam = 0 }) => {
      const { data } = await api.get<CallsResponse>('/api/agents/calls/', {
        params: { filter, limit: PAGE_SIZE, offset: pageParam },
      })
      return data
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage.calls || lastPage.calls.length < PAGE_SIZE) return undefined
      return allPages.reduce((sum, p) => sum + (p.calls?.length || 0), 0)
    },
  })
}

/** Compteurs (missed today, voicemails non lus) — extrait de la 1ère page. */
export function useCallCounts(filter: CallFilter = 'all') {
  const query = useCallLogs(filter)
  const first = query.data?.pages[0]
  return {
    missedCount: first?.missed_count ?? 0,
    totalToday: first?.total_today ?? 0,
    unreadVoicemailCount: first?.unread_voicemail_count ?? 0,
  }
}
